// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__OqYAG","label":"styles_label__wa2V9","icon":"styles_icon__O621c"};